import styled, { css } from 'styled-components';

const buttonModifiers = {
  primary: () => css`
    background-color: #74a50a;
  `,

  secondary: () => css`
    background-color: #235f6e;
  `,
};

export const Container = styled.div`
  ${({ variant = 'primary' }) => css`
    button {
      height: 34px;
      padding: 0 20px;
      border-radius: 3.5px;
      border: none;
      color: #fff;
      display: flex;
      align-items: center;
      ${variant && buttonModifiers[variant]}
    }
  `}
`;
